/* Registre paresseux des Web Components.
 *
 * `base.njk` charge uniquement ce fichier (`<script type="module">`).
 * Au chargement puis à chaque mutation du DOM, on scanne la liste des tags
 * connus et on n'`import()` dynamiquement que les bundles des composants
 * effectivement présents dans la page (une seule fois par composant).
 *
 * Les bundles sont produits par `vite build` (voir vite.config.js) sous
 * `/assets/js/<tag>.js`. Vite découpe automatiquement le code partagé
 * (chart.js, three, leaflet…) dans `/assets/js/chunks/`.
 */

const TAGS = [
  "definition-box",
  "remarque-box",
  "exercice-box",
  "phrase-manipulator",
  "word-clicker",
  "category-sorter",
  "math-interactif",
  "parametric-graph",
  "mermaid-diagram",
  "equation-latex",
  "molecule-3d",
  "scene-3d",
  "timeline-frise",
  "carte-interactive",
  "video-anim",
];

// Map tag → import() dynamique. Vite remplace ces URLs par les chemins bundlés.
const LOADERS = {
  "definition-box": () => import("./components/definition-box.js"),
  "remarque-box": () => import("./components/remarque-box.js"),
  "exercice-box": () => import("./components/exercice-box.js"),
  "phrase-manipulator": () => import("./components/phrase-manipulator.js"),
  "word-clicker": () => import("./components/word-clicker.js"),
  "category-sorter": () => import("./components/category-sorter.js"),
  "math-interactif": () => import("./components/math-interactif.js"),
  "parametric-graph": () => import("./components/parametric-graph.js"),
  "mermaid-diagram": () => import("./components/mermaid-diagram.js"),
  "equation-latex": () => import("./components/equation-latex.js"),
  "molecule-3d": () => import("./components/molecule-3d.js"),
  "scene-3d": () => import("./components/scene-3d.js"),
  "timeline-frise": () => import("./components/timeline-frise.js"),
  "carte-interactive": () => import("./components/carte-interactive.js"),
  "video-anim": () => import("./components/video-anim.js"),
};

const loaded = new Set();

function discover(root) {
  for (const tag of TAGS) {
    if (loaded.has(tag)) continue;
    if (root.querySelector(tag)) {
      loaded.add(tag);
      // Import asynchrone — erreur attrapée et journalisée (ne casse pas les autres).
      LOADERS[tag]().catch((err) => {
        // eslint-disable-next-line no-console
        console.error(`[registry] échec du chargement de <${tag}>:`, err);
      });
    }
  }
}

// 1. Au chargement (le DOM est déjà prêt : module defer).
discover(document.body);

// 2. Sur mutations (Hermes peut injecter du contenu sans recharger la page).
const observer = new MutationObserver((mutations) => {
  for (const m of mutations) {
    for (const node of m.addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE) discover(node);
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });
